module.exports = __webpack_public_path__ + "static/casual-fridays-hero-d675378eeb5af7d605cd51f2bce7051f.jpg";